module.exports = __webpack_public_path__ + "img/section5_title.7dcfb4d1.png";